// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.set-card .left-side {
  width: 75%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 28px;
  line-height: 22px;
  cursor: pointer;
}

.set-card .left-side .content {
  width: -webkit-fill-available;
  width: fill;
  display: flex;
  align-items: center;
  gap: 10px;
}
.left-side .content .heading {
  padding: 0;
  margin: 0;
  font-size: 24px;
  font-weight: 500;
  font-family: Karla;
}

.left-side .content .subheading {
  padding: 0;
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  font-family: Karla;
}

.set-card .right-side {
  width: 100%;
  /* border: 1px solid red; */
}
.set-card .right-side .image-div {
  margin: 0;
  padding: 0;
  position: relative;
  width: 100%;
  height: 100%;
}

.set-card .right-side .image-div-partial {
  margin: 0;
  padding: 0;
  position: relative;
  width: 100%;
  height: 100%;
}

.set-card .right-side .image-div img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}

.set-card .right-side .image-div-partial img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
  border: 3px solid #f23d3d;
}

.set-card .right-side button {
  height: 40px;
  margin-top: 5px;
  background-color: #ffffff;
  color: #e77b7b;
  font-size: 18px;
  font-weight: 500;
  font-family: Poppins;
  transition: height 0.5s ease;
  text-transform: none;
}

.set-card .right-side .btn-delete {
  color: #e77b7b;
  border: 0.5px solid #e77b7b;
}

.set-card .right-side .btn-unarchive {
  width: 97%;
  /* width: 100%; */
  color: #50c878;
  border: 0.5px solid #50c878;
}

.btn-width {
  width: 100% !important;
}

.set-card .right-side .btnAdd {
  height: 40px;
  margin-top: 5px;
  background-color: #ffffff;
  color: #50c878;
  font-size: 18px;
  font-weight: 500;
  font-family: Poppins;
  transition: height 0.5s ease;
  text-transform: none;
}

.set-card .right-side .btnAdded {
  height: 40px;
  margin-top: 5px;
  background-color: #50c878;
  color: #ffffff;
  font-size: 18px;
  font-weight: 500;
  font-family: Poppins;
  transition: height 0.5s ease;
  text-transform: none;
}

.set-card .overlayText {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.25rem;
}

.set-card .middle-side {
  width: 16%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 34px;
  line-height: 22px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/setcard.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,6BAAW;EAAX,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,UAAU;EACV,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,2BAA2B;AAC7B;AACA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":[".set-card .left-side {\n  width: 75%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 28px;\n  line-height: 22px;\n  cursor: pointer;\n}\n\n.set-card .left-side .content {\n  width: fill;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.left-side .content .heading {\n  padding: 0;\n  margin: 0;\n  font-size: 24px;\n  font-weight: 500;\n  font-family: Karla;\n}\n\n.left-side .content .subheading {\n  padding: 0;\n  margin: 0;\n  font-size: 14px;\n  font-weight: 400;\n  font-family: Karla;\n}\n\n.set-card .right-side {\n  width: 100%;\n  /* border: 1px solid red; */\n}\n.set-card .right-side .image-div {\n  margin: 0;\n  padding: 0;\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.set-card .right-side .image-div-partial {\n  margin: 0;\n  padding: 0;\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.set-card .right-side .image-div img {\n  width: 100%;\n  height: 100%;\n  border-radius: 5px;\n}\n\n.set-card .right-side .image-div-partial img {\n  width: 100%;\n  height: 100%;\n  border-radius: 5px;\n  border: 3px solid #f23d3d;\n}\n\n.set-card .right-side button {\n  height: 40px;\n  margin-top: 5px;\n  background-color: #ffffff;\n  color: #e77b7b;\n  font-size: 18px;\n  font-weight: 500;\n  font-family: Poppins;\n  transition: height 0.5s ease;\n  text-transform: none;\n}\n\n.set-card .right-side .btn-delete {\n  color: #e77b7b;\n  border: 0.5px solid #e77b7b;\n}\n\n.set-card .right-side .btn-unarchive {\n  width: 97%;\n  /* width: 100%; */\n  color: #50c878;\n  border: 0.5px solid #50c878;\n}\n\n.btn-width {\n  width: 100% !important;\n}\n\n.set-card .right-side .btnAdd {\n  height: 40px;\n  margin-top: 5px;\n  background-color: #ffffff;\n  color: #50c878;\n  font-size: 18px;\n  font-weight: 500;\n  font-family: Poppins;\n  transition: height 0.5s ease;\n  text-transform: none;\n}\n\n.set-card .right-side .btnAdded {\n  height: 40px;\n  margin-top: 5px;\n  background-color: #50c878;\n  color: #ffffff;\n  font-size: 18px;\n  font-weight: 500;\n  font-family: Poppins;\n  transition: height 0.5s ease;\n  text-transform: none;\n}\n\n.set-card .overlayText {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  color: #ffffff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1.25rem;\n}\n\n.set-card .middle-side {\n  width: 16%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 34px;\n  line-height: 22px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
